import { PawPrint } from 'lucide-react';

/**
 * Large, warm hero for a single pet: the animal's photo, name and a gentle
 * one-line identity. The emotional centre of the portal home.
 */
function primaryPhoto(pet) {
  if (!pet || !Array.isArray(pet.photos) || pet.photos.length === 0) return null;
  return pet.photos.find((p) => p.isPrimary && p.url) || pet.photos.find((p) => p.url) || null;
}

function describeAge(birthDate) {
  if (!birthDate) return null;
  const ms = Date.now() - new Date(birthDate).getTime();
  if (ms < 0) return null;
  const years = Math.floor(ms / (365.25 * 24 * 60 * 60 * 1000));
  if (years >= 1) return `${years} ${years === 1 ? 'anno' : 'anni'}`;
  const months = Math.max(1, Math.round(ms / (30.44 * 24 * 60 * 60 * 1000)));
  return `${months} ${months === 1 ? 'mese' : 'mesi'}`;
}

export function PetHero({ pet }) {
  if (!pet) return null;
  const photo = primaryPhoto(pet);
  const species = pet.speciesId && pet.speciesId.name;
  const breed = pet.breedId && pet.breedId.name;
  const age = describeAge(pet.birthDate);
  const subtitle = [breed || species, age].filter(Boolean).join(' · ');

  return (
    <div className="flex flex-col items-center text-center">
      <div className="relative h-44 w-44 overflow-hidden rounded-full border-4 border-portal-card shadow-portal sm:h-56 sm:w-56">
        {photo ? (
          <img src={photo.url} alt={pet.name} className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-portal-bg-soft text-portal-ink-faint">
            <PawPrint className="h-16 w-16" strokeWidth={1.5} />
          </div>
        )}
      </div>
      <h1 className="mt-5 text-3xl font-semibold tracking-tight text-portal-ink">{pet.name}</h1>
      {subtitle && <p className="mt-1 text-portal-ink-muted">{subtitle}</p>}
    </div>
  );
}
